import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';

import * as fromGraphql from './wards.graphql'
import * as fromActions from './wards.actions'

@Injectable()
export class WardsEffects {

  getAllWards$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllWards),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_WARDS,
        fetchPolicy: 'network-only',
        variables: {
          districUniqueId: action.districUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadWardss({ wardss: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {}
}
